<template>
  <v-container class="menu-main-categories-view" v-if="mainCategories.length > 0">
    <v-btn v-scroll="onScroll" v-show="fab" color="primary" fab fixed bottom right @click="toTop()" class="up-catalogo-productos">
      <v-icon>fa-light fa-chevron-up</v-icon>
    </v-btn>

    <v-row class="row-banner mt-1" v-if="instance.ads_active">
      <v-col class="col-banner-main-categories pt-0" cols="12"  >
        <topsort-main-category-header ></topsort-main-category-header>
      </v-col>
    </v-row>
    
    <main-category-custom 
        :mainCategories="mainCategories" 
        v-if="instance.cluvi_add_ons?.includes('custom_banner')" 
        @clickMain="clickMain($event)">
    </main-category-custom>
    <main-category-basic 
        :mainCategories="mainCategories" 
        @clickMain="clickMain($event)" v-else>
    </main-category-basic>

    <delivery-current-cart-bottom v-if="(service === 'delivery' || service === 'take_away') && (purchaseId !== null || taPurchaseId !== null)" />
    <on-table-current-cart-bottom v-if="service ==='on_table' && (otPurchaseId !== null || (supplier.on_table_class === 'basic' && supplier.has_cluvi_pay))" @emptyList="showDialog" />
    <ot-dialog
      v-if="otdialog"
      :data="dialogData"
      @dismiss="otdialog = false"
      @gotomenu="otdialog = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { misMixins } from "@/mixins/mixins.js";
import { track } from "../services/track-custom";
import { dbFunctions } from '@/services/indexedDB';
import { menu } from "../services/menu";
import * as Sentry from '@sentry/browser';

export default {
  name: "MenuMainCategories",
  beforeRouteLeave(to, from, next) {
    if (to.name === "Menu") {
      if (this.service === "on_table" && !to.query.category_id) next({ name: "OnTableHome" });
      else next();
      if ((this.service === "take_away" || this.service === "delivery") && !to.query.category_id) next({ name: "Home" });
      else next();
    } else {
      next();
    }
  },
  components: {
    DeliveryCurrentCartBottom: () => import(/* webpackChunkName: "deliveryCurrentCartBottom" */ '@/components/delivery/CurrentCartBottom'),
    OnTableCurrentCartBottom: () => import(/* webpackChunkName: "onTableCurrentCartBottom" */ '@/components/on_table/CurrentCartBottom'),
    OtDialog: () => import(/* webpackChunkName: "otDialog" */ '@/components/on_table/OtDialog.vue'),
    TopsortMainCategoryHeader: () => import(/* webpackChunkName: "TopsortMainCategoryHeader" */ '@/components/topsort/TopsortMainCategoryHeader'),
    MainCategoryBasic: () => import(/* webpackChunkName: "MainCategoryBasic" */ '@/components/menu/MainCategoryBasic'),
    MainCategoryCustom: () => import(/* webpackChunkName: "MainCategoryCustom" */ '@/components/menu/MainCategoryCustom')
  },
  data:() => ({
    total: 0,
    fab: false,
    shoppingCart: {total: 0},
    otdialog: false,
    dialogData: {
      title: '',
      message: '',
      btns: []
    },
    mainCategories: []
  }),
  computed: {
    ...mapState('customer', ["instance", "supplier"]),
    ...mapState('order', ['service', 'subservice', 'purchaseId', 'taPurchaseId', 'otPurchaseId']),
    ...mapState('shared', ['openMenuTop', 'mainCategoryId']),
    ...mapState('template', ['isFirefox']),
    ...mapGetters('order', ["is_ontable_service"]),
  },
  watch: {
    supplier (val) {
      if (!val?.id) this.GoSelectSupplier();
    },
    $route() {
      if (this.$route.query.category_id) this.$store.state.shared.productsFilter = Number(this.$route.query.category_id) === 0 ? "all" : Number(this.$route.query.category_id);
    },
    openMenuTop(val) {
      if (val) this.TemplateActiveHeader({ header_type: this.instance.back_option_menu });
    }
  },
  created() {
    this.routeHome();
    if (this.service !== 'on_table' || this.isFirefox) this.getMainCategoriesApi();
    else this.getMainCategoriesCached();
    this.reloadGetSupplier();
    this.initMenuMainCategories();
  },
  mixins: [ misMixins ],
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    ...mapMutations('template', ["SetLoading", "TemplateActiveHeader", "setisFirefox"]),
    ...mapMutations('shared', ['setMainCategory', 'setOpenMenuTop', 'SetProductId']),
    ...mapMutations('order', ['setService']),
    initMenuMainCategories () {
      this.TemplateActiveHeader({ header_type: this.instance.back_option_menu });
      if (this.$route.query.category_id) this.$store.state.shared.productsFilter = Number(this.$route.query.category_id) === 0 ? "all" : Number(this.$route.query.category_id);
    },
    clickMain(category) {
      this.setMainCategory(category.id);
      track.trackEventCluvi({ maincategory_id: category.id },"click main category");
      if (category.product_supplier_id) {
        track.trackEventCluvi({ product: category.product_supplier_id },"show product from main category");
        this.SetProductId(category.product_supplier_id);
      } else {
        this.gotoSubCategories(category.id);
      };
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    getMainCategoriesCached () {
      dbFunctions.getCategoriesIDB()
        .then(response => {
          if (response.length) {
            this.mainCategories = response;
            this.SetLoading(false);
          };
        })
        .catch(error => {
          this.setisFirefox(true);
          this.getMainCategoriesApi();
          Sentry.captureException(error);
          track.trackEventCluvi({ }, "IndexDB set ModeApi by MainCategories");
        });
    },
    async getMainCategoriesApi() {
      try {
        const mainCategories = await menu.getMainCategories();
        mainCategories.data.forEach(function(element, index) {
          mainCategories.data[index].loading = true;
        });
        this.mainCategories = mainCategories.data;
        if (this.mainCategories.length === 0) {
          this.gotoHome();
        } else {
          this.mainCategories.forEach(value => {
            if (this.openMenuTop && this.mainCategoryId === value.id) this.setOpenMenuTop(false);
          });
          this.SetLoading(false);
        };
      } catch (error) {
        (error);
        this.SetLoading(true);
      };
    },
    showDialog(data) {
      this.dialogData = { ...this.dialogData, ...data};
      this.otdialog = true;
    },
    gotoSubCategories (id) {
      this.SetLoading(true);
      this.$router.push({
        name: "SubCategories",
        params: { supplier_id: this.supplier.slug },
        query: { maincategory_id: id }
      }).catch(err => err);;
    },
    gotoHome () {
      this.$router.push({
        name: "Home",
        params: { supplier_id: this.supplier.slug }
      }).catch(err => err);
    },
    loadImage (index) {
      this.mainCategories[index].loading = false;
    },
    GoSelectSupplier() {
      this.$router.push({ name: "Main" });
    },
    routeHome () {
      if (this.supplier.id == 0) {
        this.$router.push({
          name: "OnTableHome",
          params: { supplier_id: this.$route.params.supplier_id }
        });
      };
    },
  },
  mounted() {
    track.trackView(this, `Menu`, `/${this.supplier.slug}/maincategories`);
    track.trackEventCluvi({}, "view maincategories");
    if (!this.service || this.service === 'book') this.setService('on_table');
    if (this.instance.new_menu_v3 === true && this.service === 'on_table' && this.supplier.on_table_class === 'basic') {
      let url = window.location.origin;
      let idSupplier = this.supplier.id.toString();
      window.open(url + '/newmenu/' + idSupplier + '/on_table/basic','_self');
    }
  },
  metaInfo() {
    return {
      title: this.supplier.label
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  justify-content: center !important;
  align-items: center !important;
}
.row-banner {
  height: inherit;
  align-items: center;
  align-content: center;
}

@keyframes bblFadInOut {
  0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em }
  40% { box-shadow: 0 2.5em 0 0 }
}

.col-banner-main-categories{
  line-height: 0 !important;
}
</style>